module.exports = __webpack_public_path__ + "static/media/cyber-security.9c1d7860.png";